var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlaneTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6929 4.15694C21.6929 4.15694 21.6929 4.16631 21.6929 4.171L16.2366 22.1654C16.1541 22.4576 15.9841 22.7177 15.7494 22.9105C15.5148 23.1034 15.2269 23.2199 14.9241 23.2444C14.881 23.2482 14.8379 23.2501 14.7948 23.2501C14.5111 23.2509 14.233 23.1706 13.9935 23.0187C13.754 22.8667 13.5629 22.6493 13.4429 22.3923L10.0951 15.3244C10.062 15.2545 10.0514 15.1761 10.0647 15.0999C10.0779 15.0237 10.1144 14.9535 10.1691 14.8988L15.5373 9.52975C15.672 9.38795 15.746 9.19914 15.7435 9.00357C15.741 8.808 15.6622 8.62114 15.5239 8.48284C15.3856 8.34454 15.1987 8.26574 15.0031 8.26323C14.8076 8.26073 14.6187 8.33472 14.477 8.46944L9.10039 13.8376C9.04574 13.8923 8.97551 13.9288 8.89931 13.942C8.82312 13.9553 8.74469 13.9447 8.67476 13.9116L1.64351 10.5807C1.36737 10.4542 1.13498 10.2486 0.975763 9.98988C0.816551 9.7312 0.737681 9.43109 0.74914 9.12756C0.76441 8.81559 0.877351 8.51632 1.072 8.27204C1.26664 8.02777 1.53315 7.85085 1.83383 7.76631L19.8282 2.31006H19.8423C20.0985 2.23808 20.3692 2.23556 20.6267 2.30275C20.8842 2.36994 21.1192 2.50443 21.3076 2.69242C21.4959 2.8804 21.6309 3.11512 21.6986 3.37248C21.7663 3.62984 21.7643 3.90059 21.6929 4.15694Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTilt);
export default __webpack_public_path__ + "static/media/PaperPlaneTilt.d82f0731325d949301565dd02e045e5f.svg";
export { ForwardRef as ReactComponent };